import { render, staticRenderFns } from "./RutePenyebranganEdit.vue?vue&type=template&id=3a2a1948&scoped=true"
import script from "./RutePenyebranganEdit.vue?vue&type=script&lang=js"
export * from "./RutePenyebranganEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2a1948",
  null
  
)

export default component.exports